// useDeviceInfo.ts
import * as UAParser from 'ua-parser-js';

type DeviceInfo = {
    browser: {
        name: string;
        version: string;
        major: string;
    };
    engine: {
        name: string;
        version: string;
    };
    os: {
        name: string;
        version: string;
    };
    device: {
        vendor: string;
        model: string;
        type: string;
    };
    cpu: {
        architecture: string;
    };
    userAgent: string;
    language: string;
    isMobile: boolean;
    cpuCores: string | number;
    deviceMemory: number;
    screenWidth: number;
    screenHeight: number;
    pixelRatio: number;
    ipData: any;
};

export async function getDeviceInfo(): Promise<DeviceInfo> {

    // Fetch IP and location data
    let ipData: any;
    let result: any = {};
    try {
        const response = await fetch('https://ipapi.co/json/');
        const parser = new UAParser.UAParser();

        result = parser?.getResult() || {};
        ipData = await response?.json();
    } catch (error) {
        console.error('Error fetching IP and location data:', error);
    }

    const info: DeviceInfo = {
        browser: {
            name: result?.browser?.name || 'Unknown',
            version: result?.browser?.version || 'Unknown',
            major: result?.browser?.major || 'Unknown',
        },
        engine: {
            name: result?.engine?.name || 'Unknown',
            version: result?.engine?.version || 'Unknown',
        },
        os: {
            name: result?.os?.name || 'Unknown',
            version: result?.os?.version || 'Unknown',
        },
        device: {
            vendor: result?.device?.vendor || 'Unknown',
            model: result?.device?.model || 'Unknown',
            type: result?.device?.type || 'desktop',
        },
        cpu: {
            architecture: result?.cpu?.architecture || 'Unknown',
        },
        userAgent: navigator?.userAgent || 'Unknown',
        language: navigator?.language || 'Unknown',
        isMobile: result?.device?.type === 'mobile' || result?.device?.type === 'tablet',
        cpuCores: navigator?.hardwareConcurrency || 'Unknown',
        deviceMemory: (navigator as any)?.deviceMemory || 0,
        screenWidth: window?.screen?.width || 0,
        screenHeight: window?.screen?.height || 0,
        pixelRatio: window?.devicePixelRatio || 0,
        ipData: ipData || undefined,
    };

    return info;
}